"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jurisdictions = require("./jurisdictions");

var _IDCounter = _interopRequireDefault(require("../utils/IDCounter"));

var _getAlabamaRulesList = _interopRequireDefault(require("./rules/getAlabamaRulesList"));

var _getArizonaRulesList = _interopRequireDefault(require("./rules/getArizonaRulesList"));

var _getCaliforniaRulesList = _interopRequireDefault(require("./rules/getCaliforniaRulesList"));

var _getColoradoRulesList = _interopRequireDefault(require("./rules/getColoradoRulesList"));

var _getDelawareRulesList = _interopRequireDefault(require("./rules/getDelawareRulesList"));

var _getFederalRulesList = _interopRequireDefault(require("./rules/getFederalRulesList"));

var _getFloridaRulesList = _interopRequireDefault(require("./rules/getFloridaRulesList"));

var _getGeorgiaRulesList = _interopRequireDefault(require("./rules/getGeorgiaRulesList"));

var _getIdahoRulesList = _interopRequireDefault(require("./rules/getIdahoRulesList"));

var _getIllinoisRulesList = _interopRequireDefault(require("./rules/getIllinoisRulesList"));

var _getIndianaRulesList = _interopRequireDefault(require("./rules/getIndianaRulesList"));

var _getIowaRulesList = _interopRequireDefault(require("./rules/getIowaRulesList"));

var _getKansasRulesList = _interopRequireDefault(require("./rules/getKansasRulesList"));

var _getLouisianaRulesList = _interopRequireDefault(require("./rules/getLouisianaRulesList"));

var _getMaineRulesList = _interopRequireDefault(require("./rules/getMaineRulesList"));

var _getMarylandRulesList = _interopRequireDefault(require("./rules/getMarylandRulesList"));

var _getMississippiRulesList = _interopRequireDefault(require("./rules/getMississippiRulesList"));

var _getMissouriRulesList = _interopRequireDefault(require("./rules/getMissouriRulesList"));

var _getMontanaRulesList = _interopRequireDefault(require("./rules/getMontanaRulesList"));

var _getNebraskaRulesList = _interopRequireDefault(require("./rules/getNebraskaRulesList"));

var _getNevadaRulesList = _interopRequireDefault(require("./rules/getNevadaRulesList"));

var _getNorthCarolinaRulesList = _interopRequireDefault(require("./rules/getNorthCarolinaRulesList"));

var _getNorthDakotaRulesList = _interopRequireDefault(require("./rules/getNorthDakotaRulesList"));

var _getOhioRulesList = _interopRequireDefault(require("./rules/getOhioRulesList"));

var _getOklahomaRulesList = _interopRequireDefault(require("./rules/getOklahomaRulesList"));

var _getSouthCarolinaRulesList = _interopRequireDefault(require("./rules/getSouthCarolinaRulesList"));

var _getSouthDakotaRulesList = _interopRequireDefault(require("./rules/getSouthDakotaRulesList"));

var _getTennesseeRulesList = _interopRequireDefault(require("./rules/getTennesseeRulesList"));

var _getUtahRulesList = _interopRequireDefault(require("./rules/getUtahRulesList"));

var _getVirginiaRulesList = _interopRequireDefault(require("./rules/getVirginiaRulesList"));

var _getWestVirginiaRulesList = _interopRequireDefault(require("./rules/getWestVirginiaRulesList"));

var _getWyomingRulesList = _interopRequireDefault(require("./rules/getWyomingRulesList"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
} // Returns rules for setting exemptions in specified jurisdiction; by default returns all rules


function getExemptionRules() {
  var jurisdiction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _jurisdictions.FEDERAL;
  var isResident = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var idCounter = new _IDCounter["default"]();
  var rulesList = [];

  switch (jurisdiction) {
    case _jurisdictions.FEDERAL:
      rulesList = (0, _getFederalRulesList["default"])(idCounter);
      break;

    case 'AL':
      rulesList = isResident ? (0, _getAlabamaRulesList["default"])(idCounter) : (0, _getFederalRulesList["default"])(idCounter);
      break;

    case 'AK':
      rulesList = (0, _getFederalRulesList["default"])(idCounter);
      break;

    case 'AZ':
      rulesList = isResident ? (0, _getArizonaRulesList["default"])(idCounter) : (0, _getFederalRulesList["default"])(idCounter);
      break;

    case 'AR':
      rulesList = (0, _getFederalRulesList["default"])(idCounter);
      break;

    case 'CA':
      rulesList = (0, _getCaliforniaRulesList["default"])(idCounter);
      break;

    case 'CO':
      rulesList = isResident ? (0, _getColoradoRulesList["default"])(idCounter) : (0, _getFederalRulesList["default"])(idCounter);
      break;

    case 'CT':
      rulesList = (0, _getFederalRulesList["default"])(idCounter);
      break;

    case 'DC':
      rulesList = (0, _getFederalRulesList["default"])(idCounter);
      break;

    case 'DE':
      rulesList = isResident ? (0, _getDelawareRulesList["default"])(idCounter) : (0, _getFederalRulesList["default"])(idCounter);
      break;

    case 'FL':
      rulesList = isResident ? (0, _getFloridaRulesList["default"])(idCounter) : (0, _getFederalRulesList["default"])(idCounter);
      break;

    case 'GA':
      rulesList = isResident ? (0, _getGeorgiaRulesList["default"])(idCounter) : (0, _getFederalRulesList["default"])(idCounter);
      break;

    case 'HI':
      rulesList = (0, _getFederalRulesList["default"])(idCounter);
      break;

    case 'ID':
      rulesList = isResident ? (0, _getIdahoRulesList["default"])(idCounter) : (0, _getFederalRulesList["default"])(idCounter);
      break;

    case 'IL':
      rulesList = isResident ? (0, _getIllinoisRulesList["default"])(idCounter) : (0, _getFederalRulesList["default"])(idCounter);
      break;

    case 'IN':
      rulesList = isResident ? (0, _getIndianaRulesList["default"])(idCounter) : (0, _getFederalRulesList["default"])(idCounter);
      break;

    case 'IA':
      rulesList = isResident ? (0, _getIowaRulesList["default"])(idCounter) : (0, _getFederalRulesList["default"])(idCounter);
      break;

    case 'KS':
      rulesList = isResident ? (0, _getKansasRulesList["default"])(idCounter) : (0, _getFederalRulesList["default"])(idCounter);
      break;

    case 'KY':
      rulesList = (0, _getFederalRulesList["default"])(idCounter);
      break;

    case 'LA':
      rulesList = (0, _getLouisianaRulesList["default"])(idCounter);
      break;

    case 'MA':
      rulesList = (0, _getFederalRulesList["default"])(idCounter);
      break;

    case 'MD':
      rulesList = (0, _getMarylandRulesList["default"])(idCounter);
      break;

    case 'ME':
      rulesList = (0, _getMaineRulesList["default"])(idCounter);
      break;

    case 'MI':
      rulesList = (0, _getFederalRulesList["default"])(idCounter);
      break;

    case 'MN':
      rulesList = (0, _getFederalRulesList["default"])(idCounter);
      break;

    case 'MS':
      rulesList = isResident ? (0, _getMississippiRulesList["default"])(idCounter) : (0, _getFederalRulesList["default"])(idCounter);
      break;

    case 'MO':
      rulesList = (0, _getMissouriRulesList["default"])(idCounter);
      break;

    case 'MT':
      rulesList = isResident ? (0, _getMontanaRulesList["default"])(idCounter) : (0, _getFederalRulesList["default"])(idCounter);
      break;

    case 'NE':
      rulesList = isResident ? (0, _getNebraskaRulesList["default"])(idCounter) : (0, _getFederalRulesList["default"])(idCounter);
      break;

    case 'NV':
      rulesList = isResident ? (0, _getNevadaRulesList["default"])(idCounter) : (0, _getFederalRulesList["default"])(idCounter);
      break;

    case 'NH':
      rulesList = (0, _getFederalRulesList["default"])(idCounter);
      break;

    case 'NJ':
      rulesList = (0, _getFederalRulesList["default"])(idCounter);
      break;

    case 'NM':
      rulesList = (0, _getFederalRulesList["default"])(idCounter);
      break;

    case 'NY':
      rulesList = (0, _getFederalRulesList["default"])(idCounter);
      break;

    case 'NC':
      rulesList = isResident ? (0, _getNorthCarolinaRulesList["default"])(idCounter) : (0, _getFederalRulesList["default"])(idCounter);
      break;

    case 'ND':
      rulesList = isResident ? (0, _getNorthDakotaRulesList["default"])(idCounter) : (0, _getFederalRulesList["default"])(idCounter);
      break;

    case 'OH':
      rulesList = isResident ? (0, _getOhioRulesList["default"])(idCounter) : (0, _getFederalRulesList["default"])(idCounter);
      break;

    case 'OK':
      rulesList = isResident ? (0, _getOklahomaRulesList["default"])(idCounter) : (0, _getFederalRulesList["default"])(idCounter);
      break;

    case 'OR':
      rulesList = (0, _getFederalRulesList["default"])(idCounter);
      break;

    case 'PA':
      rulesList = (0, _getFederalRulesList["default"])(idCounter);
      break;

    case 'RI':
      rulesList = (0, _getFederalRulesList["default"])(idCounter);
      break;

    case 'SC':
      rulesList = isResident ? (0, _getSouthCarolinaRulesList["default"])(idCounter) : (0, _getFederalRulesList["default"])(idCounter);
      break;

    case 'SD':
      rulesList = idCounter ? (0, _getSouthDakotaRulesList["default"])(idCounter) : (0, _getFederalRulesList["default"])(idCounter);
      break;

    case 'TN':
      rulesList = idCounter ? (0, _getTennesseeRulesList["default"])(idCounter) : (0, _getFederalRulesList["default"])(idCounter);
      break;

    case 'TX':
      rulesList = (0, _getFederalRulesList["default"])(idCounter);
      break;

    case 'UT':
      rulesList = (0, _getUtahRulesList["default"])(idCounter);
      break;

    case 'VT':
      rulesList = (0, _getFederalRulesList["default"])(idCounter);
      break;

    case 'VA':
      rulesList = isResident ? (0, _getVirginiaRulesList["default"])(idCounter) : (0, _getFederalRulesList["default"])(idCounter);
      break;

    case 'WA':
      rulesList = (0, _getFederalRulesList["default"])(idCounter);
      break;

    case 'WV':
      rulesList = (0, _getWestVirginiaRulesList["default"])(idCounter);
      break;

    case 'WI':
      rulesList = (0, _getFederalRulesList["default"])(idCounter);
      break;

    case 'WY':
      rulesList = isResident ? (0, _getWyomingRulesList["default"])(idCounter) : (0, _getFederalRulesList["default"])(idCounter);
      break;

    default:
      rulesList = (0, _getFederalRulesList["default"])(idCounter);
      break;
  }

  return rulesList;
}

var _default = getExemptionRules;
exports["default"] = _default;